module.exports = __webpack_public_path__ + "img/sprinkle-14.44d9ac38.jpg";